import type { FieldValueDto } from '@lib/dto/envelope.dto'

/** Field values as their JSON, keyed by field id, for comparing drafts. */
export type DraftTexts = ReadonlyMap<string, string>

export function draftTexts(fields: readonly { id: string; value: FieldValueDto }[]): DraftTexts {
  return new Map(fields.map((field) => [field.id, JSON.stringify(field.value)]))
}

/**
 * Brings a draft another tab saved into this tab's. A field this tab changed
 * since its own last save (`base`) keeps this tab's value, so nothing typed
 * here is lost; every other field takes the saved one. When both tabs changed
 * the same field, this tab's edit is the newer and wins.
 */
export function mergeDraft(
  base: DraftTexts,
  mine: Readonly<Record<string, FieldValueDto>>,
  theirs: Readonly<Record<string, FieldValueDto>>,
): Record<string, FieldValueDto> {
  const merged: Record<string, FieldValueDto> = { ...theirs }
  for (const [id, value] of Object.entries(mine)) {
    if (JSON.stringify(value) !== base.get(id)) merged[id] = value
  }
  // A field this tab cleared since its last save stays cleared.
  for (const id of base.keys()) {
    if (!(id in mine) && id in merged && base.get(id) === JSON.stringify(theirs[id])) delete merged[id]
  }
  return merged
}
